import apiService from './apiService';
import { EmailCampaign } from '../store/slices/emailCampaignSlice';

export const getCampaigns = async (): Promise<EmailCampaign[]> => {
  const response = await apiService.get<EmailCampaign[]>('/email-campaigns');
  return response.data;
};

export const getCampaignById = async (id: string): Promise<EmailCampaign> => {
  const response = await apiService.get<EmailCampaign>(`/email-campaigns/${id}`);
  return response.data;
};

export const createCampaign = async (campaignData: Omit<EmailCampaign, 'id' | 'kols' | 'createdAt' | 'updatedAt'>): Promise<EmailCampaign> => {
  const response = await apiService.post<EmailCampaign>('/email-campaigns', campaignData);
  return response.data;
};

export const updateCampaign = async (id: string, campaignData: Partial<EmailCampaign>): Promise<EmailCampaign> => {
  const response = await apiService.put<EmailCampaign>(`/email-campaigns/${id}`, campaignData);
  return response.data;
};

export const deleteCampaign = async (id: string): Promise<void> => {
  await apiService.delete(`/email-campaigns/${id}`);
};

export const addKolToCampaign = async (
  campaignId: string,
  kolData: {
    kolId: string;
    dateTime: string;
    numberOfPeople: number;
    treatment: string;
  }
): Promise<any> => {
  const response = await apiService.post(`/email-campaigns/${campaignId}/kols`, kolData);
  return response.data;
};

export const removeKolFromCampaign = async (campaignId: string, kolCampaignId: string): Promise<void> => {
  await apiService.delete(`/email-campaigns/${campaignId}/kols/${kolCampaignId}`);
};

export const updateKolCampaignStatus = async (
  campaignId: string,
  kolCampaignId: string,
  status: 'pending' | 'confirmed' | 'canceled'
): Promise<any> => {
  const response = await apiService.patch(`/email-campaigns/${campaignId}/kols/${kolCampaignId}`, { status });
  return response.data;
}; 